import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonFunction } from 'src/app/service/commonfunction';
import { GetListService } from 'src/app/service/getlist.service';
import { NotificationService } from 'src/app/service/notification.service';
import { PostService } from 'src/app/service/post.service';
import $ from 'jquery'
import { IdbService } from 'src/app/service/idb.service';
@Component({
  selector: 'app-popupcommonfeedback',
  templateUrl: './popupcommonfeedback.component.html',
  styleUrls: ['./popupcommonfeedback.component.scss']
})
export class PopupcommonfeedbackComponent implements OnInit {
  @ViewChild('fileInput') el: ElementRef;
  GetData: any;
  submitted: any = false;
  scheduleListId: any = [];
  attendanceDate;
  displayAttendanceDate: any;
  StudnetListArray:any;
  profilephoto1: any = "";
  profilephoto2: any = "";
  profilephoto3: any = "";
  constructor(
    public dialogRef: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public getListService: GetListService,
    public idbService: IdbService,
    public commonFunction: CommonFunction,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    public postService: PostService,
    public router: Router,
    private notifyService: NotificationService
  ) { }

  ngOnInit(): void {
    this.GetData = this.data;
    this.StudnetListArray = this.GetData.studentList

    this.attendanceDate = this.GetData.AttendanceDate
    this.displayAttendanceDate = this.datePipe.transform(this.GetData.AttendanceDate, 'MMM dd,yy')
    if (this.GetData.BatchId.length > 0) {
      this.scheduleListId = this.GetData.BatchId
    }
    else {
      this.scheduleListId.push(this.GetData.BatchId);
    }


  }
  closemodel() {
    this.dialogRef.closeAll();
  }

  uploadAgeProofImage1(event) {
    // console.log(event.target.id);
    if (event.target.id == "filetwo1") {
      var file2: File = event.target.files[0];
      var myReader1: FileReader = new FileReader();      
      myReader1.onloadend = (e) => {
        this.profilephoto1 = myReader1.result;
      }      
      // console.log("photo1" + this.profilephoto1);
      
      myReader1.readAsDataURL(file2);
    }
    else if (event.target.id == "filetwo2") {
      var file2: File = event.target.files[0];
      var myReader2: FileReader = new FileReader();      
      myReader2.onloadend = (e) => {
        this.profilephoto2 = myReader2.result;
      }      
      // console.log(this.profilephoto2);
      
      myReader2.readAsDataURL(file2);
    }
  
    else if (event.target.id == "filetwo3") {
      var file2: File = event.target.files[0];
      var myReader3: FileReader = new FileReader();      
      myReader3.onloadend = (e) => {
        this.profilephoto3 = myReader3.result;
      }      
      // console.log(this.profilephoto3);
      
      myReader3.readAsDataURL(file2);
    }
  
  }

  // uploadAgeProofImage2(event) {
  //   // debugger;
    
  //   if (event.target.id == "filetwo2") {
  //     var file22: File = event.target.files[0];
  //     var myReader2: FileReader = new FileReader();      
  //     myReader2.onloadend = (e) => {
  //       this.profilephoto2 = myReader2.result;
  //     }      
  //     console.log(this.profilephoto2);
      
  //     myReader2.readAsDataURL(file22);
  //   }
  // }

  // uploadAgeProofImage3(event) {
  //   if (event.target.id == "filetwo3") {
  //     var file2: File = event.target.files[0];
  //     var myReader1: FileReader = new FileReader();      
  //     myReader1.onloadend = (e) => {
  //       this.profilephoto3 = myReader1.result;
  //     }      
  //     // console.log(this.profilephoto);
      
  //     myReader1.readAsDataURL(file2);
  //   }
  // }

  public SaveAttendance() {
    this.submitted = true;
    var GetUserData = this.commonFunction.GetUserData();
    // console.log(GetUserData);
    
    let BatchIdList = (this.scheduleListId.length > 1) ? this.scheduleListId.join(',') : this.scheduleListId[0];
    var data =
    {
      BatchIdList: BatchIdList,
      userAttendance:
      {
        AcademyId: GetUserData.AcademyId,
        CreatedDate: new Date(),
        Createdby: GetUserData.UserId,
        Latitude: this.GetData.Latitude,
        Longitude: this.GetData.Longitude,
        AcademyBatchId: BatchIdList,
        AttendanceDate: this.datePipe.transform(this.attendanceDate, 'MM/dd/yyyy'),
        Homework: $('#txt_homework').val(),
        Diet: $('#txt_diet').val(),
        Comments: $('#txt_comment').val(),
        Slot: this.GetData.slot,
      },
      LoginAudit: {
        Latitude: this.GetData.Latitude,
        Longitude: this.GetData.Longitude
      },
      leaveTypeList: this.StudnetListArray.LeaveTypeListSArray,
      userList: this.StudnetListArray.StudentFeedBackArray,
      academySetting: {
        AcademyId: 0,
        FeesTracking: false,
        LeaveReasonRequired: true
      },
      userId : GetUserData.UserId,
      imgpic1 : this.profilephoto1,
      imgpic2 : this.profilephoto2,
      imgpic3 : this.profilephoto3
    };
    this.spinner.show();
    // console.log(data);
    
    if (window.navigator.onLine == false) {
      let array = [], that = this;
      array.push(data);
      if (array.length > 0) {

        this.idbService.getAllData("academyuserattendance").then((responseattendance: any) => {
          let userlistattendance = responseattendance;
          if (userlistattendance.length > 0) {
            for (let index = 0; index < userlistattendance.length; index++) {
              let curdate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')
              let attdate = this.datePipe.transform(this.attendanceDate, 'MM/dd/yyyy')
              if (attdate == curdate) {
                this.idbService.deleteItems("academyuserattendance", userlistattendance[index].id);
              }
            }
            array.forEach(function (item) {
              that.idbService.addItemsObs("academyuserattendance", item);
              that.notifyService.showSuccess("Offline Attendance saved successfully!", "");
              that.dialogRef.closeAll();
            });
          }
          else {
            array.forEach(function (item) {
              that.idbService.addItemsObs("academyuserattendance", item);
              that.notifyService.showSuccess("Offline Attendance saved successfully!", "");
              that.dialogRef.closeAll();
            });
          }
        });



        //  this.dialogRef.close("#popup3");
        //  this.dialogRef.close("#popup2");

        // $("#popup3").modal("hide")
        // $("#popup2").modal("hide")
        // $("#popup1").modal("hide")

        // this.router.navigate(['/dashboard'])
        this.spinner.hide();
      }
    }
    else {
      this.postService
        .saveAttendance(data)
        .subscribe((response: any) => {

          if (response == null || response != null || response == undefined) {
            this.notifyService.showSuccess("Attendance saved successfully!", "");
            setTimeout(() => {
              this.router.navigate(['/dashboard'])
                .then(() => {
                  window.location.reload();
                });
            }, 1000);
            this.spinner.hide();
          }
          else {
            this.notifyService.showError("Unable to save attendance. Please try again later. Contact the admin if problem persists.", "");
          }
        },
          (error) => {
            this.submitted = false;
            if (window.navigator.onLine == false) {
              this.notifyService.showError("NO INTERNET CONNECTION DETECTED.", "");
              // this.commonFunction.SetAttendanceStorageData(data);

            }
            else {
              this.notifyService.showError("Unable to save attendance. Please try again later. Contact the admin if problem persists.", "");
            }
            this.spinner.hide();
          });
    }

  }

}
